import useFetch from 'utils/hooks/useFetch'
import { ApiGetDashboardInfo } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function DashboardService() {
    const { showFail } = useModal()

    const { fetch: apiGetDashboardData } = useFetch(ApiGetDashboardInfo)

    const fetchDashboardInfo = async (dateFrom, dateTo, month) => {
        const res = await apiGetDashboardData({
            data: {
                dateFrom,
                dateTo,
                month
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchDashboardInfo
    }
}